<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" *ngIf="loadAPIcall && likedByList?.length==0">
  <app-common-skeleton [countforView]="10" [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
</div>
<div class="sub-entities-scroll-container" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false"
  [infiniteScrollThrottle]="200" [alwaysCallback]="true" (scrolled)="onScrollDown()">
  <ng-container *ngIf="likedByList.length>0; else noResult;">
    <div class="hpanel" *ngFor="let items of likedByList; let lastItem = last;">
      <div class="panel-body border-radius-top-left-right-6 sectionate"
        [ngClass]="{'disabled':jobDetails?.status !='ACTIVE'}">
        <div class="row">
          <div class="col-sm-8">
            <div class="view-card">
              <img id="job_liked_user_profile_image" *ngIf="items.logo != undefined && items.logo != null " class="img-circle m-r-4" src={{items.logo}}
                (click)="profile(items.userId)">

              <div *ngIf="items.logo == undefined || items.logo == null">
                <div class="circles" [style.background-color]="getColortwo(items?.firstName, items?.lastName)">
                  <div class="circle-text"[style.color]="getTextColor(items?.firstName, items?.lastName)">{{ getInitialstwo(items?.firstName, items?.lastName) }}</div>
                </div>
              </div>

              <div class="details-grid">
                <div class="view-name">
                  <h6 class="fw-bold m-0">
                    {{items.firstName}} {{" "}} {{items.lastName}}
                  </h6>
                </div>

                <div class="view-title">
                  <span *ngIf="items.UserType == 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
                  <span *ngIf="items.UserType == 'RECRUITER'">Recruiter</span>
                  <span *ngIf="items.UserType == 'JOB_SEEKER'">Job Seeker</span>
                  <span *ngIf="items.UserType == 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
                  <span *ngIf="items.UserType == 'BENCH_RECRUITER'">Bench Recruiter</span>
                  <span *ngIf="items.organisation"> &#64;</span> {{items.organisation}}
                </div>
                <div class="view-time">
                  <span> Liked at {{items.activityDate| timezoneDate}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="LoginUserId!=items.userId" class="col-sm-4 chaticon">
           <div id="job_liked_chat_button" class="chat-button"
           title="{{items?.nonSeenMessageCount}} Messages" (click)="chatuser(items, connectionTemplate)">
             <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
             <span  class="blue-color">{{items?.nonSeenMessageCount}}</span>
             <span >Chat</span>
           </div>
          </div>

        </div>
      </div>
    </div>
    <div class="gs-end-of-list" *ngIf="stopscrollFlag && likedByList.length>0">
      <div class="wert">
        <div class="col-md-12 mg-bt-9">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
        </div>
        <div class="col-md-12">
          <p class="font-16">You've reached the bottom of the page</p>
        </div>
      </div>
    </div>
    <app-common-skeleton *ngIf="loadAPIcall && likedByList?.length>0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
  </ng-container>
</div>

<ng-template #noResult>
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
    <ng-icon name="tablerZoomQuestion"></ng-icon>
  </div>
    <div class="col-md-12 fig">No likes yet. </div>
  </div>
</ng-template>
</ng-container>

<ng-container *ngIf="designVersion === 'v3'">
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires. -->
  <!-- Job-level disable: blocked / non-active job greys the V3 Likes
       listing and blocks pointer events. Matches V2 wrapper above.
       Bound per-row below (not on this wrapper) so it no longer also dims
       the "No Likes Yet" empty state, which has nothing to grey out or
       block clicks on. -->
  <div infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="200"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()">
    <app-common-skeleton *ngIf="loadAPIcall && likedByList?.length === 0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <!-- Click on avatar / name / info area routes to the liker's public
         profile. Mirrors baseline V2 pattern which wired
         `(click)="profile(items.userId)"` on the image. -->
    <div class="jc-v3-person-item" *ngFor="let items of likedByList"
      [ngClass]="{'disabled': jobDetails?.status !== 'ACTIVE'}">
      <img *ngIf="items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [src]="items.logo" alt="avatar"
        (click)="profile(items.userId)"
        (error)="$any($event.target).style.display='none'">
      <div *ngIf="!items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [style.background-color]="getColortwo(items?.firstName, items?.lastName)"
        [style.color]="getTextColor(items?.firstName, items?.lastName)"
        (click)="profile(items.userId)">
        {{ getInitialstwo(items?.firstName, items?.lastName) }}
      </div>
      <div class="jc-v3-p-info jc-v3-p-clickable" (click)="profile(items.userId)">
        <div class="jc-v3-p-name">{{ items?.firstName }} {{ items?.lastName }}</div>
        <div class="jc-v3-p-role">
          <span *ngIf="items.UserType == 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
          <span *ngIf="items.UserType == 'RECRUITER'">Recruiter</span>
          <span *ngIf="items.UserType == 'JOB_SEEKER'">Job Seeker</span>
          <span *ngIf="items.UserType == 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
          <span *ngIf="items.UserType == 'BENCH_RECRUITER'">Bench Recruiter</span>
          <span *ngIf="items?.organisation"> &middot; {{ items.organisation }}</span>
        </div>
      </div>
      <div class="jc-v3-p-time">{{ items?.activityDate | timezoneDate }}</div>
      <button type="button" class="jc-v3-p-chat"
        *ngIf="LoginUserId != items.userId"
        
        (click)="chatuser(items, connectionTemplate); $event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        <span class="jc-v3-p-chat-count" *ngIf="items?.nonSeenMessageCount > 0">{{ items.nonSeenMessageCount }}</span>
        <span>Chat</span>
      </button>
    </div>
    <app-common-skeleton *ngIf="loadAPIcall && likedByList?.length > 0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <div *ngIf="stopscrollFlag && likedByList?.length > 0" class="jc-v3-list-done">
      <ng-icon name="tablerCircleCheck"></ng-icon>
      <p>You've reached the bottom of the page</p>
    </div>
    <div *ngIf="!loadAPIcall && likedByList?.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <path d="M100 122 C100 122 62 98 62 74 a22 22 0 0 1 38-14 a22 22 0 0 1 38 14 C138 98 100 122 100 122Z" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
        <path d="M100 114 C100 114 70 94 70 76 a16 16 0 0 1 30-8 a16 16 0 0 1 30 8 C130 94 100 114 100 114Z" fill="#DDD6FE"/>
        <circle cx="148" cy="130" r="16" fill="#7C3AED" opacity="0.10"/>
        <circle cx="148" cy="130" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <path d="M148 137 C148 137 140 132 140 127 a8 8 0 0 1 8-5 a8 8 0 0 1 8 5 C156 132 148 137 148 137Z" fill="#DDD6FE" stroke="#7C3AED" stroke-width="1.2"/>
        <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
        <circle cx="60" cy="120" r="2.5" fill="#A78BFA" opacity="0.5"/>
      </svg>
      <h3>No Likes Yet</h3>
      <p>Candidates who like this job will appear here.</p>
    </div>
  </div>
</ng-container>



<ng-template #connectionTemplate>
  <app-connection-template [page]="'job-card-1'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values"></app-connection-template>
</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>
